"use client";

// Small client pieces of the isomorphic UI kit (page.tsx / badge.tsx) that need translated
// attribute strings. Props are plain serialisable values so server components can render them.
import Link from "next/link";
import type { ReactNode } from "react";
import { useT } from "@/components/i18n-ui/provider";

export function BreadcrumbNav({ children }: { children: ReactNode }) {
  const t = useT("ui");
  return <nav aria-label={t("breadcrumb")} className="mb-2 flex flex-wrap items-center gap-1 text-sm text-ink-500">{children}</nav>;
}

export function PaginationView({ page, pages, total, prevHref, nextHref }: { page: number; pages: number; total: number; prevHref?: string; nextHref?: string }) {
  const t = useT("ui");
  return (
    <nav className="mt-4 flex items-center justify-between text-sm text-ink-600" aria-label={t("pagination.label")}>
      <span>{t("pagination.summary", { page, pages, total })}</span>
      <span className="flex gap-2">
        {prevHref && <Link className="btn-secondary btn-sm" href={prevHref} rel="prev">{t("pagination.previous")}</Link>}
        {nextHref && <Link className="btn-secondary btn-sm" href={nextHref} rel="next">{t("pagination.next")}</Link>}
      </span>
    </nav>
  );
}
